<!-- https://fonts.google.com/icons?selected=Material+Icons -->
<div *ngIf="authorService.isAuthenticated(); else elseBlock">
  <app-home></app-home>
</div>
<ng-template #elseBlock>
  <router-outlet></router-outlet>
</ng-template>